// Module
var code = "<h2 id=\"aes-ein-number\">AES&#39; EIN Number</h2> <p>American Education Services&#39; Federal Identification Number, or EIN, is <strong>231693362</strong>.</p> ";
// Exports
export default code;